import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate, Route, Routes } from 'react-router-dom';
import Product from './prouctList.component'


function ProductBase() {
    const { isLoggedIn } = useSelector(state => state.auth);
    if (!isLoggedIn) {
        return <Navigate to="/login/" />;
    }

    return (
        <>
            <div className="col-md-12">
                <Routes>
                    <Route path="/" element={<Product />} />
                </Routes>
            </div>
        </>
    );
}

export default ProductBase;